/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverRankTierConfigAdminDto } from '../models/DriverRankTierConfigAdminDto';
import type { PostDriverRankTierConfigAdminRequest } from '../models/PostDriverRankTierConfigAdminRequest';
import type { PutDriverRankTierConfigAdminRequest } from '../models/PutDriverRankTierConfigAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverRankTierConfigsService {
    /**
     * **Required Policy:** `ViewDriverRankTierConfigs`
     * @returns DriverRankTierConfigAdminDto OK
     * @throws ApiError
     */
    public static getDriverRankTierConfigsAdmin({
        regionId,
    }: {
        regionId?: number,
    }): CancelablePromise<Array<DriverRankTierConfigAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverranktierconfigs',
            query: {
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverRankTierConfigs`
     * @returns DriverRankTierConfigAdminDto OK
     * @throws ApiError
     */
    public static postDriverRankTierConfigAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverRankTierConfigAdminRequest,
    }): CancelablePromise<DriverRankTierConfigAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverranktierconfigs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverRankTierConfigs`
     * @returns DriverRankTierConfigAdminDto OK
     * @throws ApiError
     */
    public static getDriverRankTierConfigByIdAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverRankTierConfigAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverranktierconfigs/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverRankTierConfigs`
     * @returns DriverRankTierConfigAdminDto OK
     * @throws ApiError
     */
    public static putDriverRankTierConfigAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutDriverRankTierConfigAdminRequest,
    }): CancelablePromise<DriverRankTierConfigAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/driverranktierconfigs/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteDriverRankTierConfigs`
     * @returns void
     * @throws ApiError
     */
    public static deleteDriverRankTierConfigAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/driverranktierconfigs/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
